

export function isLoading(layer) {
  return layer._loadingTiles > 0;
}
